// extracted by mini-css-extract-plugin
module.exports = {"background":"index-module--background--3WPrO","nav":"index-module--nav--NTkBo"};